/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-operations-maximize': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M13.125 1.25V2.5h3.494l-5.994 5.988.881.887L17.5 3.381v3.494h1.25V1.25h-5.625zm-3.75 10.262l-.881-.887L2.5 16.619v-3.494H1.25v5.625h5.625V17.5H3.381l5.994-5.988z"/>'
  }
})
